/**
 * Supported job action types
 */
export var JobActionType;
(function (JobActionType) {
    JobActionType["RERUN"] = "rerun";
    JobActionType["CANCEL"] = "cancel";
    JobActionType["EDIT_METADATA"] = "edit_metadata";
})(JobActionType || (JobActionType = {}));
//# sourceMappingURL=job-actions.js.map